"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Favorite(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M16.5 3C19.538 3 22 5.462 22 8.5c0 4.171-4.913 8.213-6.281 9.49-1.577 1.47-3.72 3.36-3.72 3.36s-2.14-1.89-3.718-3.36C6.912 16.713 2 12.671 2 8.5A5.5 5.5 0 0 1 7.5 3C10.396 3 12 5.09 12 5.09S13.605 3 16.5 3zm0 2c-1.828 0-2.905 1.295-2.915 1.307L12 8l-1.585-1.693C10.386 6.275 9.329 5 7.5 5 5.57 5 4 6.57 4 8.5c0 2.92 3.769 6.327 5.19 7.61.176.158.329.3.455.416.75.698 1.64 1.503 2.354 2.145.716-.642 1.604-1.446 2.356-2.145.125-.117.278-.257.455-.416C16.232 14.827 20 11.42 20 8.5 20 6.57 18.43 5 16.5 5z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Favorite;
